import { Avatar, useMediaQuery } from '@material-ui/core'
import { Rating } from '@material-ui/lab'
import { Review } from './ProductReviews'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { MOBILE_BREAKPOINT } from '../../utils/constants'


const ReviewCard = ({ data, noBorder }: { data: Review, noBorder: boolean }) => {
  const photosCDN = "https://cdn.stamped.io/uploads/photos/"
  const stringAvatar = (name: string) => {
    return {
      style: {
        backgroundColor: '#f2a1b2',
      },
      children: `${name.charAt(0).toUpperCase()}`,
    };
  }

  const isMobile = useMediaQuery(MOBILE_BREAKPOINT, { noSsr: true })
  const reviewDate = new Date(data.reviewDate)
  const images = data?.reviewUserPhotos?.length >= 1 ? data.reviewUserPhotos.split(',') : []

  return (
    <div className={`review-card`}>
      <div className="review-header">
        <div className="header-left">
          <div className="avatar">
            <Avatar {...stringAvatar(data.author)} />
          </div>
          <div className="user-info">
            <p className="paragraph mb-0">{data.author}</p>
            <Rating style={{ fontSize: '1.8rem' }} name="half-rating" size="small" value={data.reviewRating} precision={0.5} readOnly />
          </div>
        </div>
        <div className="header-right"><p className="paragraph">{reviewDate.toLocaleDateString()}</p></div>
      </div>

      <div className="review-body" style={noBorder ? { border: 'none' } : {}}>
        <h4 style={{ fontWeight: 600, color: 'var(--asphalt-grey)' }}>{data.reviewTitle}</h4>
        <p className="paragraph">{data.reviewMessage}</p>
        {images.length > 0 && (
          images.map(img => (
            <Zoom key={`${photosCDN}${img}`} zoomMargin={isMobile ? 10 : 50} wrapElement='div' overlayBgColorEnd='rgba(0, 0, 0, 0.6)'>
              <img src={`${photosCDN}${img}`} className={`img-fluid review-image`} alt="" />
            </Zoom>
          ))
        )}
      </div>
    </div>
  )
}

export default ReviewCard
